let Slider = function () {

    this.setSlider = function (slider) {
      let isDown = false;
      let isDragging = false;
      let startX;
      let scrollLeft;

      slider.addEventListener("mousedown", (e) => {
        isDown = true;
        isDragging = false;

        slider.classList.add("is-dragging");

        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      slider.addEventListener("mousemove", (e) => {
        if (!isDown) return;

        e.preventDefault();

        const x = e.pageX - slider.offsetLeft;
        const walk = x - startX;

        if (Math.abs(walk) > 5) {
            isDragging = true;
        }

        slider.scrollLeft = scrollLeft - walk;
      });

      slider.addEventListener("mouseleave", () => {
        isDown = false;

        slider.classList.remove("is-dragging");
      });

      slider.addEventListener("mouseup", () => {
        isDown = false;

        slider.classList.remove("is-dragging");
      });

      slider.addEventListener("click", (e) => {
        if (isDragging) {
            e.preventDefault();
            e.stopImmediatePropagation();
            isDragging = false;
            return false;
        }
      }, true);
    };
};

export default new Slider();
